import styled from 'styled-components';
import {ToastContainer} from 'react-toastify';
import {theme} from '@styles/theme';

export const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    z-index: 9999999;
  }
  .Toastify__toast {
    padding: 0;
    box-shadow: none;
    border-radius: ${theme.roundedBig};
  }
  .Toastify__toast--info {
    background-color: ${theme.colors.basic08};
    border: 1px solid ${theme.colors.basic06};
  }
  .Toastify__toast--error {
    background-color: ${theme.colors.basic08};
    border: 1px solid ${theme.colors.signalRed00};
  }
  .Toastify__toast--warning {
    background-color: ${theme.colors.basic08};
    border: 1px solid ${theme.colors.signalOrange00};
  }
  .Toastify__toast--success {
    background-color: ${theme.colors.basic08};
    border: 1px solid ${theme.colors.basic06};
  }
  .Toastify__toast-body {
  }
  .Toastify__progress-bar {
  }
`;

export const CloseWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
